// extracted by mini-css-extract-plugin
export var cmtDownloadCard = "styles-module--cmt-download-card--5b63c";
export var cmtDownloadCard__button = "styles-module--cmt-download-card__button--8c850";
export var cmtDownloadCard__linker = "styles-module--cmt-download-card__linker--afba2";
export var cmtDownloadCard__title = "styles-module--cmt-download-card__title--9d129";